import { Reducer } from 'redux';
import { KnownAction } from './projectsAction';
import { ProjectsState } from './projectsModels';

/* tslint:disable */
// ----------------
// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.
export const reducer: Reducer<ProjectsState> = (state: ProjectsState, action: KnownAction) => {
    if (state === null || state === undefined) {
        state = {
            projects: [],
            loading: false
        };
    }

    switch (action.type) {
        case 'SET_PROJECTS':
            return Object.assign({}, state, { projects: action.data });
        case 'SET_LOADING_PROJECT':
            return Object.assign({}, state, { loading: action.data });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/data/projects/projectsReducers.ts